/* =========================================================
 * Centrale Bundler-volumeprijsdata voor hoofdproducten en cross-sells.
 *
 * De storefront rekent hier uitsluitend een VOORVERTONING mee. Bundler
 * blijft leidend voor de echte korting in winkelwagen en checkout.
 *
 * Belangrijk voor een eenduidige voorvertoning: laat een accessoire dat
 * via cross-sell korting krijgt bij voorkeur in slechts één volumebundel
 * voorkomen.
 * ========================================================= */
window.bdBundlerVolumeDiscountRegistry =
  window.bdBundlerVolumeDiscountRegistry || {};
window.bdBundlerVolumeDiscountsReady = false;

function bdBuildBundlerVolumeDiscountRegistry(bundles) {
  const registry = {};

  (Array.isArray(bundles) ? bundles : []).forEach(
    (bundle, bundleIndex) => {
      if (
        bundle?.is_volume_bundle !== 'true' ||
        !Array.isArray(bundle.volume_discounts) ||
        bundle.volume_discounts.length === 0
      ) {
        return;
      }

      Object.values(bundle.products || {}).forEach((bundleProduct) => {
        const handle = String(bundleProduct?.handle || '').trim();

        if (!handle) {
          return;
        }

        if (!registry[handle]) {
          registry[handle] = [];
        }

        registry[handle].push({
          bundleIndex,
          discounts: bundle.volume_discounts.map((discount) => ({
            min_items: discount.min_items,
            max_items: discount.max_items,
            discount_value: discount.discount_value,
            discount_type: discount.discount_type,
          })),
        });
      });
    },
  );

  window.bdBundlerVolumeDiscountRegistry = registry;
  window.bdBundlerVolumeDiscountsReady = true;
}

window.bdGetBundlerVolumePricing = function (
  productHandle,
  quantity,
  baseUnitPriceCents,
) {
  const handle = String(productHandle || '').trim();
  const qty = Math.max(
    0,
    Number.parseInt(quantity || '0', 10) || 0,
  );
  const baseCents = Math.max(
    0,
    Math.round(Number(baseUnitPriceCents) || 0),
  );

  const fallback = {
    hasDiscount: false,
    productHandle: handle,
    quantity: qty,
    originalUnitPriceCents: baseCents,
    discountedUnitPriceCents: baseCents,
    savingUnitCents: 0,
    discountType: '',
    discountValue: 0,
    minItems: 0,
  };

  if (!handle || qty < 1 || baseCents < 1) {
    return fallback;
  }

  const bundleEntries =
    window.bdBundlerVolumeDiscountRegistry?.[handle] || [];

  if (!bundleEntries.length) {
    return fallback;
  }

  if (bundleEntries.length > 1) {
    console.warn(
      'Beschermdirect: product zit in meerdere Bundler-volumebundels; controleer de korting voor',
      handle,
    );
  }

  let bestCandidate = null;

  bundleEntries.forEach((entry) => {
    (entry.discounts || []).forEach((discount) => {
      const minItems = Math.max(
        1,
        Number.parseInt(discount.min_items || '1', 10) || 1,
      );

      const parsedMax = Number.parseInt(
        discount.max_items || '0',
        10,
      );
      const maxItems = Number.isFinite(parsedMax) && parsedMax > 0
        ? parsedMax
        : null;

      if (qty < minItems || (maxItems !== null && qty > maxItems)) {
        return;
      }

      const discountValue = Number.parseFloat(
        discount.discount_value || '0',
      );
      const discountType = String(
        discount.discount_type || '',
      );

      if (!Number.isFinite(discountValue) || discountValue <= 0) {
        return;
      }

      let discountedUnitPriceCents = baseCents;

      if (discountType === 'percentage') {
        discountedUnitPriceCents = Math.max(
          0,
          Math.round(
            baseCents * (1 - discountValue / 100),
          ),
        );
      } else if (discountType === 'fixed_amount') {
        discountedUnitPriceCents = Math.max(
          0,
          Math.round(
            baseCents - discountValue * 100,
          ),
        );
      } else {
        return;
      }

      const savingUnitCents = Math.max(
        0,
        baseCents - discountedUnitPriceCents,
      );

      if (savingUnitCents <= 0) {
        return;
      }

      const candidate = {
        hasDiscount: true,
        productHandle: handle,
        quantity: qty,
        originalUnitPriceCents: baseCents,
        discountedUnitPriceCents,
        savingUnitCents,
        discountType,
        discountValue,
        minItems,
        bundleIndex: entry.bundleIndex,
      };

      if (
        !bestCandidate ||
        candidate.minItems > bestCandidate.minItems ||
        (
          candidate.minItems === bestCandidate.minItems &&
          candidate.savingUnitCents > bestCandidate.savingUnitCents
        )
      ) {
        bestCandidate = candidate;
      }
    });
  });

  return bestCandidate || fallback;
};

document.addEventListener('bundler:loaded', function (e) {
  const bundles = window.bndlr.getBundles();

  bdBuildBundlerVolumeDiscountRegistry(bundles);

  document.dispatchEvent(
    new CustomEvent('bd:bundler-volume-discounts-ready'),
  );
  const totalPriceElement = document.getElementById('total-price');
  const totalComparePriceElement = document.getElementById('total-compare-price');
  const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));
  const decrementButton = document.querySelector('.decrement-button');
  const quantityInput = document.querySelector('.quantity-input');
  const incrementButton = document.querySelector('.increment-button');
  const option1 = document.querySelectorAll('[name="option1"]');
  const option2 = document.querySelectorAll('[name="option2"]');
  const option3 = document.querySelectorAll('[name="option3"]');
  const options = document.querySelectorAll('[name="option1"], [name="option2"], [name="option3"]');
  const crossselling = document.querySelectorAll('.crossselling-product');
  let volumeDiscounts = '';

  let currentProductHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle');
  let currentBundle = null;
  let currentProductAdded = false;

  bundles.forEach((bundle) => {
    if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
      const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
      if (bundleProduct) {
        volumeDiscounts = bundle.volume_discounts;
        displayVolumeDiscounts(volumeDiscounts);
      }
    } else {
      if (Object.values(bundle.products).some((p) => p.handle === currentProductHandle)) {
        currentBundle = bundle;
        displayBundleProducts(bundle.products);
      }
    }
  });

  if (false) {
    options.forEach((option) => {
      option.addEventListener('click', function () {
        bundles.forEach((bundle) => {
          if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
            const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
            if (bundleProduct) {
              volumeDiscounts = bundle.volume_discounts;
              displayVolumeDiscounts(volumeDiscounts);
            }
          }
        });
      });
    });
  }

  options.forEach((option) => {
    ['click', 'change'].forEach((event) => {
      option.addEventListener(event, function () {
        bundles.forEach((bundle) => {
          if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
            const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
            if (bundleProduct) {
              volumeDiscounts = bundle.volume_discounts;
              displayVolumeDiscounts(volumeDiscounts);
            }
          }
        });
      });
    });
  });

  if (quantityInput && totalPriceElement) {
    if (decrementButton) {
      decrementButton.addEventListener('click', function () {
        updateTotalPrice();
      });
    }

    if (incrementButton) {
      incrementButton.addEventListener('click', function () {
        updateTotalPrice();
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('blur', function () {
        updateTotalPrice();
      });
    }

    if (option1) {
      option1.forEach((option) => {
        option.addEventListener('click', function () {
          updateTotalPrice();
        });
      });
    }

    if (option2) {
      option2.forEach((option) => {
        option.addEventListener('click', function () {
          updateTotalPrice();
        });
      });
    }

    if (option3) {
      option3.forEach((option) => {
        option.addEventListener('click', function () {
          updateTotalPrice();
        });
      });
    }

    if (crossselling) {
      crossselling.forEach(function (product) {
        handleCrosssellingChange(product);
      });
    }
  }

  // Functions
  function displayVolumeDiscounts(volumeDiscounts) {
    const volumeDiscountContainer = document.querySelector('#volume-discount-container');
    const priceContainer = document.querySelector('#total-price');
    const comparePriceContainer = document.querySelector('#total-compare-price');
    const quantityInput = document.querySelector('.quantity-input');
    const quantityVal = parseInt(quantityInput?.value || 1);
    var highestEligible = null;
    var highestQty = -1;

    if (!volumeDiscountContainer) return;
    if (!priceContainer) return;

    volumeDiscountContainer.innerHTML = '';

    volumeDiscounts.forEach((discount) => {
      var dataVolumeQty = parseInt(discount.min_items);
      if (quantityVal >= dataVolumeQty && dataVolumeQty > highestQty) {
        highestEligible = discount;
        highestQty = dataVolumeQty;
      }
    });

    volumeDiscounts.forEach((discount) => {
      const quantity = discount.min_items;
      const discountValue = discount.discount_value;
      const discountType = discount.discount_type;

      //const originalPrice = parseFloat((priceContainer.getAttribute('data-price') || '0') / 100);
      const originalPrice = parseFloat((priceContainer.getAttribute('data-solo-price') || '0') / 100);

      console.log(originalPrice);

      if (comparePriceContainer) {
        const originalComparePrice = parseFloat(
          (comparePriceContainer.getAttribute('data-compare-price') || '0') / 100
        );
      }
      let discountedPrice, discountAmount, discountSymbol;
      let discountComparePrice, discountCompareAmount;

      if (discountType === 'percentage') {
        discountedPrice = originalPrice * (1 - discountValue / 100);
        discountAmount = originalPrice - discountedPrice;
        discountSymbol = '%';
        if (comparePriceContainer) {
          discountComparePrice = originalComparePrice * (1 - discountValue / 100);
          discountCompareAmount = originalComparePrice - discountComparePrice;
        }
      } else if (discountType === 'fixed_amount') {
        discountedPrice = originalPrice - discountValue;
        discountAmount = discountValue;
        discountSymbol = '';
        if (comparePriceContainer) {
          discountComparePrice = originalComparePrice - discountValue;
        }
        discountAmount = discountValue;
      }

      discountedPrice = parseFloat(discountedPrice).toFixed(2);

      const totalDiscountAmount = discountAmount * quantity;
      if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
        var formattedDiscountedPrice = formatMoney(discountedPrice * 1.21 * 100, '€{{amount_with_comma_separator}}');
      } else {
        var formattedDiscountedPrice = formatMoney(discountedPrice * 100, '€{{amount_with_comma_separator}}');
      }
      const formattedDiscountedComparePrice = formatMoney(
        discountComparePrice * 100,
        '€{{amount_with_comma_separator}}'
      );
      const formattedTotalDiscountAmount = formatMoney(totalDiscountAmount * 100, '€{{amount_with_comma_separator}}');

      const discountHtml = `
  <div class="grid grid-cols-12 hover-staffel cursor-pointer border border-[#DDD9D9] mb-2 rounded-[3px] w-full gap-0 ${
    highestQty == quantity ? `hover-active` : ``
  }" data-volume-quantity="${quantity}" data-discounted-price="${discountedPrice * 100}">
    <div class="flex items-center col-span-3 md:col-span-4 justify-center border-r border-[#DDD9D9] py-3">
        <span class="font-bold text-sm md:text-sm">v.a. ${quantity} st.</span>
    </div>

    <div class="flex items-end sm:items-center justify-center col-span-5 md:col-span-4 border-r border-[#DDD9D9] py-3 font-light text-sm md:text-sm">
      <div class="flex flex-col sm:flex-row">
        ${
          discountComparePrice > 0
            ? `<span class="line-through mr-3" data-excl-price="${discountComparePrice * 100}">
            ${formattedDiscountedComparePrice}
        </span>`
            : ''
        }

        <span data-excl-price="${discountedPrice * 100}">
            ${formattedDiscountedPrice}
        </span>
      </div> &nbsp p/stuk
    </div>

    <div class="flex items-center col-span-4 justify-center py-3 !text-[#9C7C00] hover-staffel-last font-semibold text-sm md:text-sm">
        <span>
            ${discountValue}${discountSymbol}
        </span>&nbsp korting
    </div>
  </div>
`;

      volumeDiscountContainer.innerHTML += discountHtml;
    });
  }

  function updateTotalPrice() {
    const volumeDiscountContainer = document.querySelector('#volume-discount-container');
    const input = document.querySelector('input[name="quantity"]');
    const quantity = parseInt(input.value, 10);
    const originalPrice = parseFloat(totalPriceElement.getAttribute('data-price') / 100);
    var originalComparePrice = 0;
    if (totalComparePriceElement) {
      var originalComparePrice = parseFloat(totalComparePriceElement.getAttribute('data-compare-price') / 100);
    }
    var totalCrosssellingPrice = 0;

    if (crossselling) {
      crossselling.forEach(function (product) {
        const checkbox = product.querySelector('input[type="checkbox"]');
        const crosssellingQuantityInput = product.querySelector('#quantity-input');

        if (checkbox && checkbox.checked && crosssellingQuantityInput) {
          const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 1);
          const crosssellingPrice = parseFloat(
            product.querySelector('[data-product-price]').getAttribute('data-product-price')
          );
          totalCrosssellingPrice += crosssellingPrice * crosssellingQuantity;
        }
      });
    }

    const discountedPrice = getDiscountedPrice(quantity, originalPrice);
    const discountedComparePrice = getDiscountedPrice(quantity, originalComparePrice);
    const totalPrice = discountedPrice * quantity + parseFloat(totalCrosssellingPrice / 100);
    const totalComparePrice = discountedComparePrice * quantity + parseFloat(totalCrosssellingPrice / 100);

    if (!isNaN(totalPrice)) {
      totalPriceElement.textContent = formatMoney(totalPrice * 100, '€{{amount_with_comma_separator}}');
      totalPriceElement.setAttribute('data-excl-price', totalPrice * 100);
      totalComparePriceElement.textContent = formatMoney(totalComparePrice * 100, '€{{amount_with_comma_separator}}');
      totalComparePriceElement.setAttribute('data-excl-price', totalComparePrice * 100);
    }
  }

  function handleCrosssellingChange(product) {
    const incrementButton = product.querySelector('#increment-button');
    const decrementButton = product.querySelector('#decrement-button');
    const quantityInput = product.querySelector('#quantity-input');
    const checkbox = product.querySelector('input[type="checkbox"]');

    incrementButton.addEventListener('click', () => {
      updateTotalPrice();
    });

    decrementButton.addEventListener('click', () => {
      updateTotalPrice();
    });

    checkbox?.addEventListener('change', () => {
      updateTotalPrice();
    });

    quantityInput.addEventListener('blur', function () {
      updateTotalPrice();
    });
  }

  function getDiscountedPrice(quantity, originalPrice) {
    const originalUnitPriceCents = Math.max(
      0,
      Math.round((Number(originalPrice) || 0) * 100),
    );

    /*
     * De Bundler-registry blijft leidend voor de prijsvoorvertoning,
     * ook wanneer de zichtbare staffeltabel via het productmetafield
     * is uitgeschakeld. Zo kan een los accessoire bijvoorbeeld direct
     * 15% Bundler-korting tonen zonder een staffelregel "v.a. 1 st.".
     */
    if (
      typeof window.bdGetBundlerVolumePricing === 'function' &&
      currentProductHandle &&
      originalUnitPriceCents > 0
    ) {
      const pricing = window.bdGetBundlerVolumePricing(
        currentProductHandle,
        quantity,
        originalUnitPriceCents,
      );

      if (pricing?.hasDiscount) {
        return pricing.discountedUnitPriceCents / 100;
      }
    }

    /*
     * Fallback voor het geval de centrale registry nog niet beschikbaar
     * is. De bestaande zichtbare staffelregels blijven dan werken zoals
     * voorheen.
     */
    var volumeDiscountContainer = document.querySelector('#volume-discount-container');
    if (volumeDiscountContainer) {
      if (volumeDiscounts) {
        for (let i = volumeDiscounts.length - 1; i >= 0; i--) {
          if (quantity >= volumeDiscounts[i].min_items) {
            const discountValue = parseFloat(volumeDiscounts[i].discount_value);
            if (volumeDiscounts[i].discount_type === 'percentage') {
              const discountedPrice = originalPrice * (1 - discountValue / 100);
              return discountedPrice;
            } else if (volumeDiscounts[i].discount_type === 'fixed_amount') {
              const discountedPrice = Math.max(0, originalPrice - discountValue);
              return discountedPrice;
            }
          }
        }
      }
    }
    return originalPrice;
  }

  function addCurrentProductToBundle(productId, variantId) {
    const product = document.querySelector(`.bndlr-product[data-product-id="${productId}"]`);
    if (product) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
        currentProductAdded = true;
        console.log('Current product added to bundle');
      } else {
        console.error(`Add button not found for current product: ${productId}`);
      }
    } else {
      console.error(`Product element not found for current product: ${productId}`);
    }
  }

  async function displayBundleProducts(products) {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;

    bundleSelector.innerHTML = '';
    const discountPercentage = parseFloat(currentBundle.percentage_value) / 100;

    const currentProduct = Object.values(products).find((p) => p.handle === currentProductHandle);
    if (currentProduct) {
      const fullProductData = await fetchProductData(currentProduct.handle);
      if (fullProductData) {
        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);
        const firstBundleProduct = document.querySelector('.first-bundle-product');

        // Add a hidden element to store current product information
        bundleSelector.innerHTML += `
          <div data-product-id="${currentProduct.id}" data-variant-id="${variant.id}" style="display: none;">
            <input
              type="checkbox"
              checked
              disabled
            >
            <span data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}"></span>
          </div>
        `;

        firstBundleProduct.innerHTML += `
        <p class="text-[#6E6E6E] text-xs line-through" data-excl-price="${originalPrice}">${formatMoney(
          originalPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>
                <p class="text-base" data-excl-price="${discountedPrice}" data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}">${formatMoney(
          discountedPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>`;

        // Add the current product to the bundle only if it hasn't been added yet
        if (!currentProductAdded) {
          addCurrentProductToBundle(currentProduct.id, variant.id);
        }
      }
    }

    // Display other products in the bundle selector
    for (const product of Object.values(products)) {
      if (product.handle !== currentProductHandle) {
        const fullProductData = await fetchProductData(product.handle);
        if (!fullProductData) continue;

        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);
        const imageUrl = fullProductData.featured_image || 'path/to/default/image.jpg';

        bundleSelector.innerHTML += `
          <div data-product-id="${product.id}" data-variant-id="${
          variant.id
        }" class="h-auto bg-white relative border border-[#DDD9D9] p-2 md:p-3 col-span-12 lg:col-span-4 flex flex-row items-center xl:flex-col gap-3 md:gap-6 xl:gap-0 rounded-[3px]">
            <div class="flex items-center mb-4 absolute right-3 top-3">
              <input
                type="checkbox"
                class="!mr-0 !w-5 !h-5 text-hightlight_light !rounded-none cursor-pointer text-highlight_light focus:ring-0"
                onChange="toggleInBundle(event, '${product.id}', '${variant.id}', ${product.sequence})"
              >
            </div>
            <img
              src="${imageUrl}"
              alt="${fullProductData.title}"
              class="w-24 md:w-32 lg:w-24 xl:w-auto h-auto object-cover aspect-square xl:mb-4"
              width="200"
              height="200"
            > 
            <div class="xl:mt-auto">
              <p class="font-bold text-base md:text-lg">${fullProductData.title}</p>
              <div class="flex flex-wrap items-center gap-2">
                <p class="text-[#6E6E6E] text-xs line-through" data-excl-price="${originalPrice}">${formatMoney(
          originalPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>
                <p class="text-base" data-excl-price="${discountedPrice}" data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}">${formatMoney(
          discountedPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>
              </div>
            </div>
          </div>
        `;
      }
    }
    updateBundlePrice();
  }

  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  window.updateBundlePrice = function () {
    if (!currentBundle) return;

    var bundleContainer = document.getElementById('bundles');
    var productPrice = bundleContainer.getAttribute('data-main-product-price');

    const mainProductPrice = parseFloat(productPrice);
    let totalPrice = 0;
    let totalOriginalPrice = 0;

    const allProducts = document.querySelectorAll('[data-bundle-selector] [data-product-id]');
    const checkedProducts = document.querySelectorAll('[data-bundle-selector] input[type="checkbox"]:checked');

    checkedProducts.forEach((checkbox) => {
      const productElement = checkbox.closest('[data-product-id]');
      const price = parseFloat(
        productElement.querySelector('[data-discounted-price]').getAttribute('data-discounted-price')
      );
      const originalPrice = parseFloat(
        productElement.querySelector('[data-original-price]').getAttribute('data-original-price')
      );
      totalOriginalPrice += originalPrice;
      totalPrice += price;
    });

    const bundleOriginalPriceElement = document.querySelector('[data-original-bundle-price]');
    const bundlePriceElement = document.querySelector('[data-bundle-price]');
    bundlePriceElement.innerHTML = formatMoney(totalPrice, '€{{amount_with_comma_separator}}');
    bundlePriceElement.setAttribute('data-excl-price', totalPrice);
    bundleOriginalPriceElement.innerHTML = formatMoney(totalOriginalPrice, '€{{amount_with_comma_separator}}');
    bundleOriginalPriceElement.setAttribute('data-excl-price', totalOriginalPrice);

    allProducts.forEach((productElement) => {
      if (productElement.style.display !== 'none') {
        const checkbox = productElement.querySelector('input[type="checkbox"]');
        const priceElement = productElement.querySelector('[data-discounted-price]');
        const originalPrice = parseFloat(priceElement.getAttribute('data-original-price'));
        const discountedPrice = parseFloat(priceElement.getAttribute('data-discounted-price'));

        if (checkbox.checked) {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.add('text-green-500');
        } else {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.remove('text-green-500');
        }
      }
    });
  };

  window.toggleInBundle = function (event, productId, variantId, index) {
    const product = document.querySelector(`.bndlr-product[data-product-id="${productId}"]`);

    if (!product) {
      console.error(`Product element not found for productId: ${productId}`);
      return;
    }

    if (event.target.checked) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
      } else {
        console.error(`Add button not found for productId: ${productId}`);
      }
    } else {
      const targetProduct = document.querySelector(
        `.bndlr-mnm-selected-products .bndlr-product[data-variant-id="${variantId}"]`
      );
      if (targetProduct) {
        const removeButton = targetProduct.querySelector('.bndlr-close');
        if (removeButton) {
          removeButton.click();
        } else {
          console.error(`Remove button not found for variantId: ${variantId}`);
        }
      } else {
        console.error(`Target product not found for variantId: ${variantId}`);
      }
    }

    updateBundlePrice();
  };

  window.addBundleToCart = function () {
    const currentProductCheckbox = document.querySelector(
      '[data-bundle-selector] [data-product-id] input[type="checkbox"]:disabled'
    );
    if (currentProductCheckbox) {
      const productId = currentProductCheckbox.closest('[data-product-id]').getAttribute('data-product-id');
      const variantId = currentProductCheckbox.closest('[data-variant-id]').getAttribute('data-variant-id');
      const addButton = document.querySelector(`.bndlr-product[data-product-id="${productId}"] .bndlr-add-to-bundle`);
      if (addButton) {
        addButton.click();
      }
    }

    // Then add the rest of the bundle to cart
    const atcButton = document.querySelector('.bndlr-add-bundle-to-cart');
    atcButton.click();
  };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
});
